import React, { useState } from "react"
import { map, get } from "lodash"

import { Panel } from "./index"
import { MiniChartComponent } from "components/molecules/chart/miniChart"
import { getCountryIcon, checkIsSp } from "utils/util"
import ClassNames from "classnames"

type PropsType = {
  chartData: Array<object>
  delete?: Function
  reloadList?: Function
  linkTechChart?: boolean
}

export const KeyVisualChart = (props: PropsType) => {
  const [chartDataNum1, changeChartDataNum1] = useState<number>(0)
  const [chartDataNum2, changeChartDataNum2] = useState<number>(1)
  const [chartDataNum3, changeChartDataNum3] = useState<number>(2)
  const [chartDataNum4, changeChartDataNum4] = useState<number>(7)
  const chartDataNumList = [
    chartDataNum1,
    chartDataNum2,
    chartDataNum3,
    chartDataNum4,
  ]
  const changeChartDataNumList = [
    changeChartDataNum1,
    changeChartDataNum2,
    changeChartDataNum3,
    changeChartDataNum4,
  ]
  const isPhone = checkIsSp()
  const chartList = map(props.chartData, (data: object, i: number) => {
    const icon = getCountryIcon(data)
    return {
      id: i,
      name: get(data, "SymbolName"),
      icon: ClassNames("icon-solid ", icon),
    }
  })
  const _chartDataNumList = !isPhone ? chartDataNumList : [chartDataNumList[0]]
  return (
    <Panel title="" className="panel-keyvisual-chart" nonePanelHeader={true}>
      <div className="summary-chart-panel">
        <ul className="chart-list-contents chart-list thin">
          {map(_chartDataNumList, (num: number, i: number) => {
            const data =
              typeof props.chartData === "object" ? props.chartData[num] : null
            return get(data, "ChartFlg") ? (
              <MiniChartComponent
                key={i}
                data={data}
                dataList={props.chartData}
                selectOption={chartList}
                listNum={num}
                changeList={changeChartDataNumList[i]}
                linkTechChart={!!props.linkTechChart}
              />
            ) : null
          })}
        </ul>
      </div>
    </Panel>
  )
}
